module.exports = __webpack_public_path__ + "img/purple-rectangle-table-4.436e80aa.png";